import { render, staticRenderFns } from "./CaseApplyManageView.vue?vue&type=template&id=bb661c92&scoped=true&"
import script from "./CaseApplyManageView.vue?vue&type=script&lang=js&"
export * from "./CaseApplyManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb661c92",
  null
  
)

export default component.exports